<template>
  <div>接口来源</div>
</template>

<script>
  export default {
    name: "project-api-source"
  }
</script>

<style scoped>

</style>
